import React, { useState } from "react";
import { signupApi } from "../api/authApi";
import { setAuthToken } from "../api/api";
import { useNavigate, Link } from "react-router-dom";
import "./suvidhaAuth.css";
import Header from "../components/layout/Header";
import heroImg from "../assets/image7.jpeg"; // use same image or another

export default function Signup() {
  const navigate = useNavigate();

  const [countryCode, setCountryCode] = useState("+91");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState(""); // optional
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  const [loading, setLoading] = useState(false);

  const isValidPhone = (v) => /^[0-9]{10}$/.test(v);
  const isValidEmail = (v) =>
    !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!fullName.trim()) return alert("Full name is required");
    if (!isValidPhone(phone.trim())) return alert("Enter valid 10-digit phone number");
    if (!isValidEmail(email)) return alert("Enter a valid email or keep it empty");
    if (!password.trim()) return alert("Password is required");
    if (password.trim().length < 6) return alert("Password must be at least 6 characters");

    try {
      setLoading(true);

      const res = await signupApi({
        full_name: fullName.trim(),
        phone: phone.trim(), // add countryCode if backend needs: `${countryCode}${phone.trim()}`
        email: email.trim() ? email.trim() : null,
        password: password.trim(),
      });

      const token = res?.data?.token;
      if (!token) throw new Error("Token not received from server");

      localStorage.setItem("token", token);
      setAuthToken(token);

      navigate("/survey/care_needs?stepNo=1");
    } catch (err) {
      alert(err?.response?.data?.message || err?.message || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Header />
    <div className="suvi-auth">
      {/* LEFT IMAGE */}
      <div className="suvi-authLeft">
        <img className="suvi-authImg" src={heroImg} alt="Suvidha signup" />
      </div>

      {/* RIGHT FORM */}
      <div className="suvi-authRight">
        <div className="suvi-authBox">
          <div className="suvi-brand">
            <div className="suvi-logoDot" aria-hidden="true" />
            <span className="suvi-brandName">Suvidha</span>
          </div>

          <h2 className="suvi-title">Create your account</h2>
          <p className="suvi-subtitle">Sign up to continue your survey</p>

          <form onSubmit={handleSignup} className="suvi-form">
            {/* FULL NAME */}
            <label className="suvi-label">
              Full Name
              <div className="suvi-pill">
                <input
                  className="suvi-input"
                  placeholder="Enter full name"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  autoComplete="name"
                />
              </div>
            </label>

            {/* PHONE */}
            <label className="suvi-label">
              Phone Number
              <div className="suvi-pill">
                <select
                  className="suvi-country"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  <option value="+91">+91</option>
                  <option value="+1">+1</option>
                  <option value="+44">+44</option>
                </select>

                <input
                  className="suvi-input"
                  placeholder="Phone number"
                  inputMode="numeric"
                  maxLength={10}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  autoComplete="tel"
                />
              </div>
            </label>

            {/* EMAIL */}
            <label className="suvi-label">
              Email (optional)
              <div className="suvi-pill">
                <input
                  className="suvi-input"
                  placeholder="Enter email (optional)"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </label>

            {/* PASSWORD */}
            <label className="suvi-label">
              Password
              <div className="suvi-pill">
                <input
                  className="suvi-input"
                  placeholder="Create password"
                  type={showPass ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                />

                <button
                  type="button"
                  className="suvi-ghostBtn"
                  onClick={() => setShowPass((s) => !s)}
                >
                  {showPass ? "Hide" : "Show"}
                </button>
              </div>
            </label>

            <button className="suvi-primaryBtn" disabled={loading} type="submit">
              {loading ? "Creating..." : "Create account"}
            </button>

            <p className="suvi-bottomText">
              Already have an account?{" "}
              <Link to="/login" className="suvi-link">Login</Link>
            </p>

            <p className="suvi-terms">
              By continuing, you agree to our{" "}
              <Link to="/terms" className="suvi-termsLink">Terms &amp; Conditions</Link>{" "}
              and{" "}
              <Link to="/terms?tab=privacy" className="suvi-termsLink">Privacy Policy</Link>.
            </p>
          </form>
        </div>
      </div>
    </div>
    </>
  );
}